import type { FaireProductEntity } from "../../entity_types/product";

export const atc_baggu_8: FaireProductEntity = {
  token: "atc_baggu_8",
  type: "product",
  name: "Standard Baggu - Cowgirl",
  brandName: "Baggu",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/2a2026fec2f6a5b29c0479d94f294409ebea6566014c2cc934d10dcb91c1aec3.jpeg",
  priceDollars: 7,
  msrpDollars: 14,
  description: "Reusable bag made from recycled materials by Baggu.",
  tags: ["bags", "accessories", "sustainable"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
